import { Wrapper } from "./styled";
import Modal from "../../../../../../../library/modal";
import { Text } from "../../../../../../../library/text";
import Button from "../../../../../../../library/button";
import { useState } from "react";
import EditModal from "./edit-modal";
import Skeleton from "react-loading-skeleton";
import {
  sendErrorNotification,
  sendSuccessNotification,
} from "../../../../../../../library/notification";
import { useAuth } from "../../../../../../../AuthContext";

const UpdateName = () => {
  const { currentUser, loading, refreshCurrentUser } = useAuth();
  const [showEditModal, setShowEditModal] = useState<boolean>(false);

  const closeEditModal = () => {
    setShowEditModal(false);
  };

  const openEditModal = () => {
    setShowEditModal(true);
  };

  const renderName = () => {
    if (loading) {
      return <Skeleton width={150} height={20} />;
    }
    return `${currentUser?.firstName} ${currentUser?.lastName}`;
  };

  const onEditSuccess = () => {
    if (!currentUser?.uid) return;
    closeEditModal();
    sendSuccessNotification("Navnet ditt ble oppdatert.");
    refreshCurrentUser();
  };

  const onEditError = () => {
    closeEditModal();
    sendErrorNotification("Kunne ikke oppdatere navnet.");
  };

  return (
    <>
      <Wrapper>
        <Text size="small" color="dark">
          {renderName()}
        </Text>
        <Button
          onClick={openEditModal}
          color="grey"
          icon="edit"
          variant="icon"
        />
      </Wrapper>
      <Modal
        onClose={closeEditModal}
        open={showEditModal}
        title="Endre navn"
        size={500}
      >
        <EditModal
          firstName={currentUser?.firstName}
          lastName={currentUser?.lastName}
          onSuccess={onEditSuccess}
          onError={onEditError}
          onClose={closeEditModal}
        />
      </Modal>
    </>
  );
};

export default UpdateName;
